import { InboundOrderDto } from './../../../../../../domain/models/dto/inbound-order.dto';
import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { BoobleModalService } from 'booble-modal';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { QuotationModalComponent } from '../../modals/quotation-modal/quotation-modal.component';
import { AuthenticationService } from 'src/app/shared/services';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { QuotationModalMobileComponent } from '../../modals/quotation-modal/quotation-modal-mobile/quotation-modal-mobile.component';

@Component({
  selector: 'app-create-order-sucess-inbound',
  templateUrl: './create-order-success-inbound.component.html',
  styleUrls: ['./create-order-success-inbound.component.scss'],
})
export class CreateOrderSuccessInboundComponent implements OnInit {
  boobleModalData: { analysisNeed: boolean; order: InboundOrderDto };
  moedas = Moedas;
  isMobile: boolean;

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  constructor(
    private modalService: BoobleModalService,
    private matIconRegistry: MatIconRegistry,
    private bottomSheet: MatBottomSheet,
    private readonly accountService: AuthenticationService,
    private domSanitzer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      'success',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/sucess.svg')
    );
  }
  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 820;
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  openQuotation() {
    const order = this.boobleModalData.order;
    if (!this.isMobile) {
      const data = {
        order,
        orderType: order.remmitanceType === 'OUTBOUND' ? 1 : 0,
        finality: order.finality,
        amount: order.amount,
        country:
          order.remmitanceType === 'OUTBOUND'
            ? order.receiver.country
            : order.sender.country,
        orderId: order.id,
        currency: this.moedas.find((moeda) => moeda.id === order.currency.id),
      };
      this.modalService.present(QuotationModalComponent, data);
    } else {
      const bottomSheetConfig = {
        data: {
          order,
          orderType: order.remmitanceType === 'OUTBOUND' ? 1 : 0,
          finality: order.finality,
          amount: order.amount,
          country:
            order.remmitanceType === 'OUTBOUND'
              ? order.receiver.country
              : order.sender.country,
          orderId: order.id,
          currency: this.moedas.find((moeda) => moeda.id === order.currency.id),
        },
      };
      this.bottomSheet.open(QuotationModalMobileComponent, bottomSheetConfig);
    }
  }
}
